<div class="completed-modal-container">
  <p>
    Uitstekend <b>{{ user?.firstName }}</b
    >,
    <br />
    {{ message }}
    <br />
    <b>Goed gewerkt!</b>
  </p>
  <img
    [src]="
      orangeThumbsUp
        ? '/assets/thumbs-up-orange.png'
        : '/assets/thumbs-up-green.png'
    "
    [alt]="'thumbs up'"
  />
  <button (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</div>
